import { render } from "./NewPassword.vue?vue&type=template&id=7e56b9be"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"
script.render = render

export default script